<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Edit Podcast</CCardHeader>
        <CCardBody v-if="loaded">
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  v-model.trim="podcastData.corporate_podcast_title"
                  label="Title"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Title"
                  @change="handleTitle"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  id="podcast_slug"
                  label="Url Name"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Url Name"
                  v-model.trim="podcastData.corporate_podcast_slug"
                  @change="handleSlug"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  v-model="podcastData.meta_info_description"
                  label="Meta Description"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Meta Description"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  v-model="podcastData.meta_info_keyword"
                  label="Meta Keyword"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Meta Keyword"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Active Date"
                  class="mb-0"
                  type="datetime-local"
                  required
                  horizontal
                  placeholder="Active Date"
                  v-model.trim="podcastData.active_date"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  v-model="podcastData.youtube_url"
                  label="Url Youtube"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Url Youtube"
              />
            </CCol>
          </CRow>
          <CRow class="form-group mt-5">
            <CCol :col="12">
              <a>Content</a>
              <editor
                  id="editor"
                  :api-key="key"
                  :init="initOption"
                  v-model="podcastData.corporate_podcast_content"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3">Display Page</label>
                <div class="col-sm-9" style="z-index: 2;">
                  <multiselect
                      horizontal
                      v-model="displayPage"
                      :options="optionsDisplayPage"
                      label="label"
                      track-by="value"
                      placeholder="Select display page"
                      :multiple="true"
                  >
                  </multiselect>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Status"
                  :options="optionsStatus"
                  required
                  horizontal
                  v-model="podcastData.status"
                  @change="handleStatus"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardBody v-else>
          <p>{{ errorMessage || "Loading..." }}</p>
        </CCardBody>
        <CCardFooter v-if="loaded">
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton color="success" class="float-right" :disabled="submitting" @click="updatePodcast">
                {{ submitting ? "Submitting..." : "Submit" }}
              </CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import jwt from "jsonwebtoken";
import Editor from "@tinymce/tinymce-vue";
import Multiselect from "vue-multiselect";
import initTinymce from "@/app/constants/initTinymce";

export default {
  name: "CorporatePodcastEdit",
  components: {
    editor: Editor,
    Multiselect,
  },
  data() {
    return {
      podcastData: {
        corporate_podcast_title: "",
        corporate_podcast_slug: "",
        meta_info_description: "",
        meta_info_keyword: "",
        active_date: "",
        youtube_url: "",
        corporate_podcast_content: "",
        status: "ACTIVE",
      },
      displayPage: [],
      optionsDisplayPage: [
        { label: "Info Seller", value: "SELLER" },
        { label: "Info Mitra", value: "MITRA" },
      ],
      optionsStatus: ["ACTIVE", "INACTIVE"],
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      initOption: initTinymce.init,
      key: initTinymce.key,
      loaded: false,
      errorMessage: "",
      submitting: false,
    };
  },
  async mounted() {
    this.authentication();
    await this.getDataByID();
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "MARKETING" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR" ||
          data.account_group === "EXTERNAL"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    getDataByID() {
      const podcastID = this.$route.params.id;
      return axios
          .get(`${this.domain}/v2/corporate_podcast/admin/${podcastID}`, {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            const data = response.data.data;
            this.podcastData = {
              corporate_podcast_title: data.corporate_podcast_title || "",
              corporate_podcast_slug: data.corporate_podcast_slug || "",
              meta_info_description: data.meta_info_description || "",
              meta_info_keyword: data.meta_info_keyword || "",
              active_date: data.active_date
                  ? moment(String(data.active_date)).format("YYYY-MM-DDTHH:mm")
                  : "",
              youtube_url: data.youtube_url || "",
              corporate_podcast_content: data.corporate_podcast_content || "",
              status: data.status || "ACTIVE",
            };
            this.displayPage = data.display_page
                ? data.display_page
                    .split(",")
                    .filter((val) => val)
                    .map((val) =>
                        this.optionsDisplayPage.find((opt) => opt.value === val) || {
                          label: val,
                          value: val,
                        }
                    )
                : [];
            this.loaded = true;
          })
          .catch((err) => {
            this.loaded = false;
            this.errorMessage =
                err.response && err.response.data && err.response.data.desc
                    ? err.response.data.desc.id
                    : "Podcast not found";
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: this.errorMessage,
            });
          });
    },
    goBack() {
      this.$router.push({ path: "/management/corporate-podcast" });
    },
    buildSlug(value) {
      return value
          .replaceAll(/[^A-Za-z0-9 -]/g, "")
          .replaceAll(" ", "-")
          .replaceAll("--", "-")
          .toLowerCase()
          .trim();
    },
    handleTitle(event) {
      const slug = this.buildSlug(event);
      document.getElementById("podcast_slug").value = slug;
      this.podcastData.corporate_podcast_slug = slug;
      this.podcastData.corporate_podcast_title = event;
    },
    handleSlug(event) {
      const slug = this.buildSlug(event);
      document.getElementById("podcast_slug").value = slug;
      this.podcastData.corporate_podcast_slug = slug;
    },
    handleStatus(event) {
      this.podcastData.status = event.target.value;
    },
    isFormValid() {
      return (
          this.podcastData.corporate_podcast_title &&
          this.podcastData.corporate_podcast_slug &&
          this.podcastData.meta_info_description &&
          this.podcastData.meta_info_keyword &&
          this.podcastData.active_date &&
          this.podcastData.youtube_url &&
          this.podcastData.corporate_podcast_content &&
          this.displayPage.length > 0
      );
    },
    updatePodcast() {
      if (this.submitting) {
        return;
      }

      if (!this.isFormValid()) {
        Swal.fire({
          icon: "error",
          text: "Title harap diisi",
          confirmButtonText: "OK",
        });
        return;
      }

      this.submitting = true;

      const podcastID = this.$route.params.id;
      const activeDate = moment(
          this.podcastData.active_date,
          "YYYY-MM-DDTHH:mm"
      ).format("YYYY-MM-DDTHH:mm:ssZ");
      const displayPageValue = this.displayPage.map((item) => item.value).join(",");

      let formData = new FormData();
      formData.append("corporate_podcast_title", this.podcastData.corporate_podcast_title);
      formData.append("corporate_podcast_slug", this.podcastData.corporate_podcast_slug);
      formData.append("meta_info_description", this.podcastData.meta_info_description);
      formData.append("meta_info_keyword", this.podcastData.meta_info_keyword);
      formData.append("active_date", activeDate);
      formData.append("youtube_url", this.podcastData.youtube_url);
      formData.append("corporate_podcast_content", this.podcastData.corporate_podcast_content);
      formData.append("display_page", displayPageValue);
      formData.append("status", this.podcastData.status);

      axios
          .put(`${this.domain}/v2/corporate_podcast/admin/${podcastID}`, formData, {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          })
          .then(() => {
            Swal.fire({
              icon: "success",
              title: `Podcast Data Updated`,
              showConfirmButton: false,
              timer: 2000,
            });
            this.$router.push({ path: `/management/corporate-podcast` });
          })
          .catch((err) => {
            this.submitting = false;
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response.data.desc.id,
            });
          });
    },
  },
};
</script>
